import { selectProperty } from '../../../actions/google/methods/select-property'
import { useAssetStore } from '@/stores/asset'

/**
 * Saves the user's selected Google Analytics property
 * @param {string} propertyId - The ID of the selected property
 * @param {string} propertyName - The name of the selected property
 * @returns {Promise<boolean>} Success status
 */
export const savePropertySelection = async (propertyId, propertyName) => {
  if (!propertyId) return false
  
  const assetStore = useAssetStore()
  
  try {
    await selectProperty(assetStore.assetId, propertyId, propertyName)
    await assetStore.setPropertyId(propertyId)
    return true
  } catch (error) {
    console.error('Error selecting property:', error)
    return false
  }
}
